import React, { useCallback } from 'react';
import { Tags } from 'opentracing';
import { setFlowId, trace } from '@pegasus/observability/client';
import { ErrorBoundary as PErrorBoundary } from '@pegasus/error-boundary';
import { tracker } from '@pegasus/tracker';
export var ErrorBoundary = function (_a) {
    var children = _a.children, componentName = _a.componentName, fallbackUI = _a.fallbackUI;
    var onError = useCallback(function (error) {
        var _a;
        var message = error.message, stack = error.stack, name = error.name;
        tracker.track('GA4-error_content', {
            event_name: 'error_content',
            error_content: {
                error_type: 'component_render_error',
                error_severity: 'high',
                info: componentName,
            },
        });
        var span = trace.startSpan('render_client_error', {
            attributes: (_a = {},
                _a[Tags.ERROR] = true,
                _a.componentName = componentName,
                _a),
        });
        setFlowId(span);
        span.setAttribute('error.name', name);
        span.setAttribute('error.message', message);
        span.addEvent('error', { message: message, stack: stack, name: name });
        span.end();
    }, [componentName]);
    return (React.createElement(PErrorBoundary, { componentName: componentName, fallbackUI: fallbackUI, onDidCatch: onError }, children));
};
